export class OptionItem {
  constructor(public label: string, public value: string) {}
}
